import React, {Component} from 'react';
import './style/map.css';

class Map extends Component {
    constructor(props) {
        super(props);
        this.leftColTitle = props.leftColTitle || '';
        this.rightColTitle = props.rightColTitle || '';
        this.title = props.title;
        this.name = props.name;
        this.keyOptions = props.keyOptions.map(key => ({key, disabled: false}));
        this.valueOptions = props.valueOptions.map(value => ({value, disabled: false}));
        this.selectKey = '';
        this.selectValue = '';
        this.btnDisabled = true;
        this.removeItem = this.removeItem.bind(this);
        this.addItem = this.addItem.bind(this);
        this.updateCheckSelectValue = this.updateCheckSelectValue.bind(this);
    }

    updateCheckSelectValue(e) {
        const select = e.target;
        this[select.name] = select.value;

        if(this.selectKey && this.selectValue){
            this.btnDisabled = false;
        }
        this.forceUpdate();
    }

    disableExistingUsedOptions() {
        const keys = Object.keys(this.props.value);
        const value = Object.values(this.props.value);

        this.keyOptions.forEach(option => {
            option.disabled = keys.indexOf(option.key) > -1;
        });

        this.valueOptions.forEach(option => {
            option.disabled = value.indexOf(option.value) > -1;
        });
    }

    onChange() {
        this.props.onChange({
            target: {
                name: this.name,
                value: this.props.value,
            }
        });
    }

    removeItem(e, key) {
        e.preventDefault();
        delete this.props.value[key];
        this.onChange();
    }

    addItem(e) {
        e.preventDefault();
        if (this.selectKey && this.selectValue) {
            this.props.value[this.selectKey] = this.selectValue;
            this.selectKey = "";
            this.selectValue = "";
            this.btnDisabled = true;
            this.onChange();
        }
    }

    render() {
        const keys = Object.keys(this.props.value);
        this.keyOptions = this.props.keyOptions.map(key => ({key, disabled: false}));
        this.valueOptions = this.props.valueOptions.map(value => ({value, disabled: false}));
        this.disableExistingUsedOptions();

        return (
            <div className={this.props.disabled ? 'fieldWrapper disabledBlock' : 'fieldWrapper'}>
                <label htmlFor={this.name}>
                    {this.title || this.name}
                </label>
                <div className="map_wrapper_head">
                    <div>{this.leftColTitle}</div>
                    <div>{this.rightColTitle}</div>
                </div>
                <div className="map" name={this.name}>
                    <div className="line selectsWrapper">
                        <select name="selectKey" id="keyOptions" value={this.selectKey}
                                onChange={this.updateCheckSelectValue}>
                            <option value="" disabled>Please select</option>
                            {this.keyOptions.map(option => {
                                return (
                                    <option key={option.key} value={option.key} disabled={option.disabled}>
                                        {option.key}
                                    </option>
                                );
                            })}
                        </select>
                        <select name="selectValue" id="valueOptions" value={this.selectValue}
                                onChange={this.updateCheckSelectValue}>
                            <option value="" disabled>Please select</option>
                            {this.valueOptions.map(option => {
                                return (
                                    <option key={option.value} value={option.value} disabled={option.disabled}>
                                        {option.value}
                                    </option>
                                );
                            })}
                        </select>
                        <button className="addItem icon" onClick={this.addItem} disabled={this.btnDisabled}> </button>
                    </div>
                    {(keys.length) ? keys.map(
                        (fieldKey, i) => <div className="line" key={i}>
                            <div className="key-value">{fieldKey}</div>
                            <div className='val-value'>{this.props.value[fieldKey]}</div>
                            <button className="removeItem icon" onClick={(e) => this.removeItem(e, fieldKey)}></button>
                        </div>
                    ) : <span>No fields...</span>}
                </div>
            </div>
        );
    }
}


export default Map;
